<template>
  <div class="main mplus">
    <Header class="header-component" page="goods"></Header>
    <div class="goods box">
      <div class="goods-title josefin title-text uppercase emekare">
        goods
      </div>
      <div class="goods-inner box">
        <div class="text">会場物販、通販・店舗にて以下のグッズを販売いたします。<br />
          ご購入方法、注意事項は<a href="#notice" data-href="#notice" class="scroll bolder">こちら</a>をご確認ください。</div>
        <div class="pamph">
          <div class="head emekare"><span class="head-text mplus">公演グッズ</span></div>
          <span class="sq">★</span><span class="bolder">パンフレット</span><br />
          <div class="item-box">
            <div class="item">
              <div class="text"><span class="bolder">〜Unit Story side MAISY〜<br class="brnosp" />パンフレット</span><br />
                <span class="desc">2,000円<span class="kakko">（税込）</span>／フルカラー／28ページ</span>
              </div>
              <img src="img/goods/01_pamph_MAISY.jpg" alt="" class="pamph-image">
            </div>
            <div class="item">
              <div class="text"><span class="bolder">〜Unit Story side Re:Fly〜<br class="brnosp" />パンフレット</span><br />
                <span class="desc">2,000円<span class="kakko">（税込）</span>／フルカラー／28ページ</span>
              </div>
              <img src="img/goods/01_pamph_ReFly.jpg" alt="" class="pamph-image">
            </div>
            <div class="item">
              <div class="text"><span class="bolder">〜Unit Story side エメ☆カレ〜<br class="brnosp" />パンフレット</span><br />
                <span class="desc">2,000円<span class="kakko">（税込）</span>／フルカラー／28ページ</span>
              </div>
              <img src="img/goods/01_pamph_EMEKARE.jpg" alt="" class="pamph-image">
            </div>

          </div>
        </div>
        <hr class="divider" />
        <div class="e-pamph align-left mplus">
          <span class="sq">★</span><span class="bolder">電子パンフレット</span><br />
          <div class="unit" v-for="(item, key) in pamph" :key="key" :class="key">
            <div class="head slider" :class="key" :data-slide="`.slide-${key}`">～Unit Story side <span class="unitLabel"
                v-html="unitLabels[key]"></span>～
              パンフレット<br />
              <span class="kakko">【 配信書店 】</span> ご購入はこちら
              <div class="icon" :class="key"><span class="material-symbols-sharp">
                  add_circle
                </span></div>
            </div>
            <div class="item-box" :class="`slide-${key}`">
              <div class="item" v-for="(url, key2) in item" :key="key2"><a :href="url" target="_blank" rel="noopener noreferrer" :class="key"  class="break-all"><span class="site-name"
                  v-html="siteLabels[key2]"></span></a><br />
              </div>
            </div>
          </div>
          <span class="bolder kakko">
            <span class="sq"></span>【 配信開始日 】</span><br />
          <time datetime="2023-07-15">7月15日（土）</time>より順次配信開始予定<br />

          <div class="notice">
            <ul>
              <li>※内容は紙版の公演パンフレットと同様です</li>
              <li>※一部書店にて、紙版との販売価格が異なる場合がございます。詳細は各販売ページよりご確認ください。</li>
            </ul>
          </div>
        </div>
        <div class="divider wide thin-white"></div>
        <!-- <div class="divider wide emekare"></div> -->
        <div class="bromide">
          <span class="sq">★</span><span class="bolder">ソロブロマイド</span><br />
          各600円<span class="kakko">（税込）</span>／L判サイズ／3枚組／全22種<br />
          <div class="item-box">

            <div class="item">
              <div class="name">
                <img src="img/goods/02_solo-1.jpg" alt="">
                ①光城新多／きたつとむ
              </div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-2.jpg" alt="">
              <div class="name">②森重優那／嶋崎裕道</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-3.jpg" alt="">
              <div class="name">③愛澤 心／大見洋太</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-4.jpg" alt="">
              <div class="name">④黒曜 護／結城伽寿也</div>
            </div>
            <div class="item last">

              <img src="img/goods/02_solo-5.jpg" alt="">
              <div class="name">⑤神谷 祈／藤希 宙</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-6.jpg" alt="">
              <div class="name">⑥青柳 帝／長塚拓海</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-7.jpg" alt="">
              <div class="name">⑦夜来立夏／柊木智貴</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-8.jpg" alt="">
              <div class="name">⑧浮間志朗／宮内伊織</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-9.jpg" alt="">
              <div class="name">⑨辺見 宙／小椋涼介</div>
            </div>
            <div class="item last">

              <img src="img/goods/02_solo-10.jpg" alt="">
              <div class="name">⑩天橋幸弥<span class="cosmo kakko">（コスモ）</span>／吉澤 翼</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-11.jpg" alt="">
              <div class="name">⑪雛瀬碧鳥／白石康介</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-12.jpg" alt="">
              <div class="name">⑫見明佐和／正木 郁</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-13.jpg" alt="">
              <div class="name">⑬小野屋あずき／大友至恩</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-14.jpg" alt="">
              <div class="name">⑭天神陽人／大久保 樹</div>
            </div>
            <div class="item last">

              <img src="img/goods/02_solo-15.jpg" alt="">
              <div class="name">⑮冠 嵐真／安部 瞬</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-16.jpg" alt="">
              <div class="name">⑯輝崎千紘／今井俊斗</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-17.jpg" alt="">
              <div class="name">⑰雅野 椿／三原大樹</div>
            </div>
            <div class="item mb">

              <img src="img/goods/02_solo-18.jpg" alt="">
              <div class="name">⑱加賀谷 蓮／野口友輔</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-19.jpg" alt="">
              <div class="name">⑲橋倉 杏／坂下陽春</div>
            </div>
            <div class="item">

              <img src="img/goods/02_solo-20.jpg" alt="">
              <div class="name">⑳雨知祭利／北原十希明</div>
            </div>
            <div class="item mb">

              <img src="img/goods/02_solo-21.jpg" alt="">
              <div class="name">㉑美和 巴／中三川歳輝</div>
            </div>
            <div class="item last-last">

              <img src="img/goods/02_solo-22.jpg" alt="">
              <div class="name">㉒荒木 冴／川上将大</div>
            </div>
          </div>
        </div>
        <div class="divider wide thin-white"></div>

        <div class="stand">
          <span class="sq">★</span><span class="bolder">アクリルスタンド</span><br />
          各800円<span class="kakko">（税込）</span>／本体：約110×50mm
          台座：約40×40mm／全15種<br />
          <div class="item-box">

            <div class="item kumi">

              <img src="img/goods/03_acrylstand_01-1.png" alt="">
              <div class="name">〈組み立て<br class="brsp">イメージ〉</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_01-2.png" alt="">
              <div class="name">①光城新多<br class="brsp">／きたつとむ</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_02.png" alt="">
              <div class="name">②森重優那<br class="brsp">／嶋崎裕道</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_03.png" alt="">
              <div class="name">③愛澤 心<br class="brsp">／大見洋太</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_04.png" alt="">
              <div class="name">④黒曜 護<br class="brsp">／結城伽寿也</div>
            </div>
            <div class="item last">

              <img src="img/goods/03_acrylstand_05.png" alt="">
              <div class="name">⑤神谷 祈<br class="brsp">／藤希 宙</div>
            </div>

            <div class="item kumi">

              <img src="img/goods/03_acrylstand_06-1.png" alt="">
              <div class="name">〈組み立て<br class="brsp">イメージ〉</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_06-2.png" alt="">
              <div class="name">⑥青柳 帝<br class="brsp">／長塚拓海</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_07.png" alt="">
              <div class="name">⑦夜来立夏<br class="brsp">／柊木智貴</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_08.png" alt="">
              <div class="name">⑧浮間志朗<br class="brsp">／宮内伊織</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_09.png" alt="">
              <div class="name">⑨辺見 宙<br class="brsp">／小椋涼介</div>
            </div>
            <div class="item last">

              <img src="img/goods/03_acrylstand_10.png" alt="">
              <div class="name">⑩天橋幸弥<span class="kakko cosmo">（コスモ）</span><br class="brsp">／吉澤 翼</div>
            </div>

            <div class="item kumi">

              <img src="img/goods/03_acrylstand_11-1.png" alt="">
              <div class="name">〈組み立て<br class="brsp">イメージ〉</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_11-2.png" alt="">
              <div class="name">⑪雛瀬碧鳥<br class="brsp">／白石康介</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_12.png" alt="">
              <div class="name">⑫見明佐和<br class="brsp">／正木 郁</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_13.png" alt="">
              <div class="name">⑬小野屋あずき<br class="brsp">／大友至恩</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_14.png" alt="">
              <div class="name">⑭天神陽人<br class="brsp">／大久保 樹</div>
            </div>
            <div class="item">

              <img src="img/goods/03_acrylstand_15.png" alt="">
              <div class="name">⑮冠 嵐真<br class="brsp">／安部 瞬</div>
            </div>
          </div>
        </div>
        <div class="divider wide thin-white"></div>
        <div class="badge">
          <span class="sq">★</span>
          <span class="bolder">ランダム缶バッジ</span><br />
          <span class="desc">500円<span class="kakko">（税込）</span>／約56mm<br />※劇場販売限定でキャスト本人のサイン付き当たり入り</span>
          <div class="item-box">

            <div class="item">
              <div class="name"><span class="bolder">〜Unit Story side MAISY〜 <br class="brnosp" />ランダム缶バッジ</span>
                <span class="desc">全12種(内シークレット2種)</span>
              </div>
              <img src="img/goods/04_badge-1.jpg" alt="">
            </div>
            <div class="item">
              <div class="name"><span class="bolder">〜Unit Story side Re:Fly〜 <br class="brnosp" />ランダム缶バッジ</span>
                <span class="desc">全12種(内シークレット2種)</span>
              </div>
              <img src="img/goods/04_badge-2.jpg" alt="">
            </div>
            <div class="item">
              <div class="name"><span class="bolder">〜Unit Story side エメ☆カレ〜 <br class="brnosp" />ランダム缶バッジ</span><br />
                <span class="desc">全12種(内シークレット2種)</span>
              </div>
              <img src="img/goods/04_badge-3.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="divider wide thin-white"></div>
        <div class="seat">
          <span class="sq">★</span><span class="bolder">ランダムクリアシート</span>
          <span class="desc">400円<span class="kakko">（税込）</span>／約70×50mm<br />※劇場販売限定でキャスト本人のサイン付き当たり入り</span>
          <div class="item-box">

            <div class="item">
              <div class="name"><span class="bolder">〜Unit Story side MAISY〜
                  <br class="brnosp" />ランダムクリアシート</span><br />
                <span class="desc">全12種 (内シークレット2種)</span>
              </div>
              <img src="img/goods/05_seat-1.png" alt="">
            </div>
            <div class="item">
              <div class="name"><span class="bolder">〜Unit Story side Re:Fly〜
                  <br class="brnosp" />ランダムクリアシート</span><br />
                <span class="desc">全12種 (内シークレット2種)</span>
              </div>
              <img src="img/goods/05_seat-2.png" alt="">
            </div>
            <div class="item">
              <div class="name"><span class="bolder">〜Unit Story side エメ☆カレ〜
                  <br class="brnosp" />ランダムクリアシート</span><br />
                <span class="desc">全12種 (内シークレット2種)</span>
              </div>
              <img src="img/goods/05_seat-3.png" alt="">
            </div>
          </div>
        </div>
        <div class="recent">
          <div class="head emekare"><span class="head-text mplus">過去グッズ</span></div>
          <span class="bolder"><span class="sq">★</span>ジュエルステージ「オンエア！」 パンフレット</span>&#x3000;2,000円<span
            class="kakko">（税込）</span>／28ページ<br />
          <span class="bolder"><span class="sq">★</span>ジュエルステージ「オンエア！」 クリアファイル(MAISY)</span>&#x3000;500円<span
            class="kakko">（税込）</span><br />
          <span class="bolder"><span class="sq">★</span>ジュエルステージ「オンエア！」 クリアファイル(Re:Fly)</span>&#x3000;500円<span
            class="kakko">（税込）</span><br />
          <span class="bolder"><span class="sq">★</span>ジュエルステージ「オンエア！」 クリアファイル(エメ☆カレ)</span>&#x3000;500円<span
            class="kakko">（税込）</span><br />
          <span class="bolder"><span class="sq">★</span>ジュエルステージ「オンエア！」～Unit Story side
            Prid’s～アクリルスタンド</span>&#x3000;各800円<span class="kakko">（税込）</span><br />
          <span class="bolder"><span class="sq">★</span>ジュエルステージ「オンエア！」～Unit Story side Prid’s～
            ランダム缶バッジ</span>&#x3000;500円<span class="kakko">（税込）</span><br />
          <span class="bolder"><span class="sq">★</span>ジュエルステージ「オンエア！」～Unit Story side Prid’s～
            ランダムクリアシート</span>&#x3000;400円<span class="kakko">（税込）</span><br />

        </div>
        <div class="original">
          <div class="head emekare"><span class="head-text mplus">原作グッズ</span></div>
          <div class="item-box">
            <div class="item">
              <div class="name"><span class="bolder"><span class="sq">★</span>ブロマイドコレクションvol.7</span><br />
                <span class="desc">385円<span class="kakko">（税込）</span>／全30種(1パック2枚入り)</span><br class="brnosp" />
              </div>
              <img src="img/goods/06_gensaku_01.png" alt="">
            </div>
            <div class="item">
              <div class="name"><span class="bolder"><span class="sq">★</span>1st
                  Anniversary <br class="brnosp" />トレーディングBIGしおり</span><br />
                <span class="desc">385円<span class="kakko">（税込）</span>／全30種</span>
              </div>
              <img src="img/goods/06_gensaku_02.png" alt="">
            </div>
            <div class="item">
              <div class="name"><span class="bolder"><span class="sq">★</span>トレーディングBIGしおり<br class="brnosp" />
                  「Le Bleuet〜薔薇と革命の協奏曲〜」</span><br />
                <span class="desc">330円<span class="kakko">（税込）</span>／全30種(1パック2枚入り)</span>
              </div>
              <img src="img/goods/06_gensaku_03.jpg" alt="">
            </div>
            <div class="item">
              <div class="name"><span class="bolder"><span class="sq">★</span>トレーディングチケットホルダー<br
                    class="brnosp" />「PRISM」</span><br />
                <span class="desc">660円<span class="kakko">（税込）</span>／全7種</span>
              </div>
              <img src="img/goods/06_gensaku_04.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="divider wide emekare"></div>
        <div class="buppan">
          <div class="head emekare"><span class="head-text mplus">劇場物販について</span></div>
          <span class="bolder"><span class="sq">■</span>販売時間<br />
            <span class="kakko">【該当公演のチケットをお持ちのお客様】</span></span><br />
          <span class="bolder">▼13:00公演</span><br />
          販売時間 12:00～13:00／終演後<br />
          <span class="bolder">▼14:00公演</span><br />
          販売時間 13:00～14:00／終演後<br />
          <span class="bolder">▼18:00公演</span><br />
          販売時間 17:00～18:00／終演後<br />
          <span class="bolder">▼19:00公演</span><br />
          販売時間 18:00～19:00／終演後<br />
          <ul>
            <li>※終演後物販は時間に限りがございます。予めご了承ください。</li>
            <li>※上記時間は該当公演のチケットをお持ちのお客様のみご購入いただけます。</li>
          </ul>
          <br />
          <span class="bolder kakko">【チケットをお持ちでないお客様】</span><br />
          各公演、開演10分後から終演15分前までご利用いただけます。<br />
          ※準備ができ次第、係員がご案内いたします。<br />
          <hr class="divider">
          <span class="bolder"><span class="sq">■</span>キャッシュレス決済について</span><br />
          劇場物販では、現金、クレジットカード、交通系電子マネー、QRコード決済がご利用いただけます。<br />
          <br />
          <span class="bolder kakko">【対応クレジットカード会社】</span><br />
          Visa、Mastercard、JCB、American Express、Diners、Discover<br />
          <span class="bolder kakko">【対応電子マネー】</span><br />
          交通系電子マネー (Suica、PASMOなど)、QRコード決済(PayPayのみ)<br />
          <span class="bolder kakko">【劇場販売注意事項】</span><br />
          <ul>
            <li>・会場の電波状況により、クレジットカード・電子マネーがご利用いただけない場合もございます。その際には現金でのお支払いに変更をお願いさせていただく場合もございますので、予めご了承ください。</li>
            <li>
              ・クレジットカードは「一括払いのみ」となります。</li>
            <li>
              ・当日はグッズ売場でのチャージはできませんので、事前に残高のご確認、およびチャージをお願いいたします。</li>
            <li>
              ・クレジットカード・電子マネーと現金との、併用払いはできません。</li>
            <li>
              ※電波状況や売場の混雑具合により、キャッシュレス決済のお取り扱いを中止させていただく場合がございます。予めご了承ください。</li>
          </ul>
        </div>
        <div class="ec">
          <div class="head emekare"><span class="head-text mplus">通販・店舗販売について</span></div>
          <span class="bolder"><span class="sq">■</span>通販</span>&#x3000;販売開始日：7月15日（土）12:00〜<br />
          ・アニメイト通販<br />
          <a href="https://www.animate-onlineshop.jp/corner/cc/onair-stage_goods/cd/2295/" target="_blank"
            rel="noopener noreferrer">https://www.animate-onlineshop.jp/corner/cc/onair-stage_goods/cd/2295/</a><br />
          ※順次お届け予定<br />
          <br />
          <span class="bolder"><span class="sq">■</span>店舗</span>&#x3000;販売開始日：7月15日（土）店舗開店時〜<br />
          ・アニメイト池袋本店<br />
          公式HP：<a href="https://www.animate.co.jp/shop/" target="_blank"
            rel="noopener noreferrer">https://www.animate.co.jp/shop/</a><br />
          総合Twitter：<a href="https://twitter.com/animateinfo" target="_blank"
            rel="noopener noreferrer">https://twitter.com/animateinfo</a><br />
          <div class="notice" id="notice">
            <span class="bolder notice-head"><span class="sq">■</span>グッズ販売における注意事項</span>
            <ul>
              <li>※公演グッズの購入制限を設けさせていただく場合がございますので、あらかじめご了承ください。</li>
              <li>※公演当日、販売のラインナップが変更になる場合がございます。</li>
              <li>※商品によっては品切れ次第、販売終了となります。予めご了承ください。</li>
              <li>※状況により開始時間の前後、販売の一時中断、中止をさせていただく場合がございます。</li>
              <li>※商品ご購入後は商品の種類と数量に間違いがないか、必ずその場でご確認をお願いいたします。<br />
                購入場所以外での交換対応は受け付けておりません。</li>
              <li>※商品に不良があった際は、当日中にスタッフまでお声がけください。</li>
              <li>※購入日以降の商品の返品・交換・返金は一切申し受け出来ませんのでご注意ください。</li>
              <li>※通販、店舗にて事前に購入いただきましたグッズについても劇場ロビーおよび劇場周辺でのトレーディング行為は禁止とさせていただきます。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar">
      <div class="text box">©col／ジュエルステージ「オンエア！」製作委員会</div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import $ from 'jquery'

export default {
  name: "Goods",
  components: {
    Header,
  },
  data: () => ({
    dayText: ["日", "月", "火", "水", "木", "金", "土"],
    time: ["13:00", "14:00", "18:00", "19:00"],
    eventBg: { "m": "maisyBg", "r": "emekareBg", "e": "emekareBg" },
    unitCode: { "m": "maisy", "r": "emekare", "e": "emekare" },
    siteLabels: { "animate": "アニメイトブックストア", "kindle": "Kindleストア", "apple": "Apple Books", "google": "Google Play ブックス", "dmm": "DMMブックス", "kobo": "楽天Kobo", "cmoa": "コミックシーモア", "honto": "Honto", "ebook": "Ebookjapan", "reader": "Reader Store" },
    pamph: { "maisy": { "animate": "https://www.animatebookstore.com/products/detail.php?product_id=1161818", "kindle": "https://www.amazon.co.jp/ebook/dp/B0CBMJHP7M/ref", "apple": "https://books.apple.com/jp/book/id6451153419", "google": "https://play.google.com/store/books/details/?id=r4HLEAAAQBAJ&hl=ja&gl=JP", "dmm": "https://book.dmm.com/product/4352783/s230asnph00099/", "kobo": "https://books.rakuten.co.jp/rk/c3233b90925a3ff2aed1e36f96f428c6/", "cmoa": "https://www.cmoa.jp/title/1101394162/", "honto": "https://honto.jp/ebook/pd_32644855.html", "ebook": "https://ebookjapan.yahoo.co.jp/books/774404/", "reader": "https://ebookstore.sony.jp/item/BT000138601400100101/" }, "refly": { "animate": "https://www.animatebookstore.com/products/detail.php?product_id=1161819", "kindle": "https://www.amazon.co.jp/ebook/dp/B0CBMGR8DX/", "apple": "https://books.apple.com/jp/book/id6451151766", "google": "https://play.google.com/store/books/details/?id=s4HLEAAAQBAJ&hl=ja&gl=JP", "dmm": "https://book.dmm.com/product/4352782/s230asnph00098/", "kobo": "https://books.rakuten.co.jp/rk/d771a639a2683f3b92357ebc2c29e359/", "cmoa": "https://www.cmoa.jp/title/1101394246/", "honto": "https://honto.jp/ebook/pd_32644854.html", "ebook": "https://ebookjapan.yahoo.co.jp/books/774405/", "reader": "https://ebookstore.sony.jp/item/BT000138601500100101/" }, "emekare": { "animate": "https://www.animatebookstore.com/products/detail.php?product_id=1161820", "kindle": "https://www.amazon.co.jp/ebook/dp/B0CBMHVMQQ/", "apple": "https://books.apple.com/jp/book/id6451152504", "google": "https://play.google.com/store/books/details/?id=sYHLEAAAQBAJ&hl=ja&gl=JP", "dmm": "https://book.dmm.com/product/4352781/s230asnph00097/", "kobo": "https://books.rakuten.co.jp/rk/7b750b7c5a0c3c9da67ee3ecf3bfa921/", "cmoa": "https://www.cmoa.jp/title/1101394247/", "honto": "https://honto.jp/ebook/pd_32644853.html", "ebook": "https://ebookjapan.yahoo.co.jp/books/774406/", "reader": "https://ebookstore.sony.jp/item/BT000138601600100101/" } },
    unitLabels: { "maisy": "MAISY", "refly": "Re:Fly", "emekare": "エメ☆カレ" }
  }),
  mounted: function () {
    this.$store.commit('setScroll');
    $('.slider').click(function () {
      let el = $(this).data('slide');
      $(el).slideToggle(400);
      $(this).toggleClass('on');
    });
  },
  methods: {
  },
}

</script>
<style scoped lang="scss">
.main {
  width: 100%;
  margin: 0 auto;
  position: relative;
  line-height: 1.7;
  padding-top: 107px;

  @media screen and (max-width: 768px) {
    background-size: 200% auto !important;
    background-position: 50% 0 !important;
  }

  background: url(../../public/img/haikei_mre.jpg) repeat;
  background-size: 100% auto;
  background-position: 0 0;
  background-attachment: fixed;
}

.header-component {
  position: relative;
  z-index: 2;
}


.divider.wide {
  padding-bottom: 0;
}

.sq {
  color: $litegreen;
  margin-right: 0.2em;
}

hr.divider {
  border: 0;
  border-top: 1px dotted $black;
  margin-top: 2rem;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}

.divider.wide {
  margin-top: 4px;
}

a {

  &:link,
  &:visited {
    color: $litegreen;
    font-weight: 600;
  }

  &:hover {
    color: white;
  }
}

.head {
  margin-top: 4rem;
  width: 100%;
  background: linear-gradient(to right, $liteorange 50%, transparent);
  padding: 0.05rem 0.5rem 0.125rem;
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  text-align: left;
  margin-bottom: 1rem;

  &.refly {
    background: linear-gradient(to right, $liteblue 50%, transparent);
  }

  &.emekare {
    background: linear-gradient(to right, $litegreen 50%, transparent);
  }

  @media screen and (max-width: 768px) {
    background: linear-gradient(to right, $liteorange 80%, transparent);
    margin-top: 2rem;
    margin-bottom: 1rem;
    line-height: 1.4;
  }

  &.narrow {
    // width: 50%;
    margin-bottom: 0;
  }
}

.title-text {
  font-size: 2.5rem;
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1;

  @media screen and (max-width: 768px) {
    font-size: 1.6rem;
    padding-top: 0;
  }
}

.goods-title {
  position: relative;

  .smaller {
    font-size: 0.6em;
  }

  &::before,
  &::after {
    position: absolute;
    content: "";
    background: url(../../public/img/emekare/title_emekare.png) no-repeat;
    width: 44px;
    height: 68px;
    bottom: 0;
    left: 4 * $rem;

    @media screen and (min-width: 1024px) {
      left: 4rem;
    }

    @media screen and (max-width: 768px) {
      left: 0;
      background-size: calc(44px * .8) calc(68px * .8);
      height: calc(68px * .8);
    }
  }

  &::after {
    transform: scaleX(-1);
    right: 4 * $rem;
    left: unset;

    @media screen and (max-width: 768px) {
      right: 0;
    }

    @media screen and (min-width: 1024px) {
      right: 4rem;
    }
  }
}

.dn {
  display: none;
}

.goods {
  padding-top: 3rem;

  &-inner {
    text-align: left;
    color: $black;
    padding-left: 4rem;
    padding-right: 4rem;
    font-size: 1 * $rem;

    @media screen and (max-width: 768px) {
      padding-left: 1rem;
      padding-right: 1rem;
      font-size: 1rem;
    }

    @media screen and (min-width: 1024px) {
      font-size: 1rem;
    }

    >.text {
      margin-top: 3rem;
    }

    .pamph {
      padding-bottom: 1rem;

      .item-box {
        display: flex;
        margin-top: 1rem;
        width: calc(100% + 4 * #{$rem});
        margin-right: -4 * $rem;

        @media screen and (max-width: 768px) {
          margin: 1rem auto;
          flex-direction: column;
          margin-bottom: -1rem;
          width: 100%;
        }

        @media screen and (min-width: 1024px) {
          width: calc(100% + 4rem);
          margin-right: -4rem;
        }

        .item {
          width: calc((100% + 1rem) / 3 - 1rem);
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;

          @media screen and (max-width: 768px) {
            width: 100%;
            margin-bottom: 3rem;
            align-items: center;
          }

          .text {
            font-size: 1 * $rem;
            color: $black;
            text-align: left;
            padding-right: 4 * $rem;
            white-space: nowrap;
            line-height: 1.6;

            @media screen and (max-width: 768px) {
              font-size: 1rem;
              padding-right: 0;
              text-align: center;
            }

            @media screen and (min-width: 1024px) {
              font-size: 1rem;
              padding-right: 4rem;
            }

            .desc {
              // font-size: 0.9em;
              line-height: 1.5;
              display: block;
            }
          }

          .pamph-image {
            width: 100%;
            margin-top: 1rem;
            padding-right: 4 * $rem;

            @media screen and (max-width: 768px) {
              padding-right: 0;
              width: 50%;
            }

            @media screen and (min-width: 1024px) {
              padding-right: 4rem;
            }
          }
        }
      }
    }

    .e-pamph {
      margin-top: 2rem;
      text-align: left;
      color: $black;
      padding-bottom: 3rem;

      .unit {
        margin-top: 1rem;
        border: 1px solid $liteorange;
        color: $black;

        &.refly {
          border-color: $liteblue;
        }

        &.emekare {
          border-color: $litegreen;
          margin-bottom: 1rem;
        }

        .head {
          font-weight: 600;
          margin-top: 0;
          margin-bottom: 0;
          background: none;
          background-color: white;
          color: $liteorange;
          position: relative;
          padding: 0.05rem 0 0.125rem 0.5rem;
          width: 100%;
          transition: 0.33s;
          line-height: 1.5;
          font-size: 1rem;

          &:hover {
            background-color: $liteorange;
            cursor: pointer;
            color: white;
          }

          &.refly {
            color: $liteblue;

            &:hover {
              color: white;
              background-color: $liteblue;
              cursor: pointer;
            }
          }

          &.emekare {
            color: $litegreen;

            &:hover {
              color: white;
              background-color: $litegreen;
              cursor: pointer;
            }
          }

          &.on .icon span {
            transform: rotate(-135deg);
            transition: 0.33s ease-out;

          }

          .icon span {
            opacity: 1;
            position: absolute;
            transition: 0.33s ease-out;
            font-weight: 600;
          }

          &:hover .icon span {
            color: white !important;
          }

          .icon {
            width: 40px;
            height: 40px;
            position: absolute;
            right: 0;
            top: 12px;
            content: "";
            color: $liteorange;
            z-index: 3;

            &.refly {
              color: $liteblue;
            }

            &.emekare {
              color: $litegreen;
            }

            @media screen and (max-width: 768px) {
              top: 16px;
              right: -6px;
            }


          }
        }

        .item {
          margin-bottom: 1rem;
          line-height: 1.5;

          &-box {
            padding: 1rem 2rem;
            display: none;
            @media screen and (max-width: 768px) {
              padding: 1rem;
            }
          }

          a {
            color: $liteorange;

            &.refly {
              color: $liteblue;
            }

            &.emekare {
              color: $litegreen;
            }

            &:hover {
              color: white;
            }
          }
        }
      }

      >.notice {
        margin-top: 2rem;
      }
    }

    .bromide {
      padding-top: 3rem;
      padding-bottom: 2rem;

      .item-box {
        display: flex;
        margin-top: 2rem;
        flex-wrap: wrap;
        width: calc(100% + 2rem);
        justify-content: flex-start;

        @media screen and (max-width: 768px) {
          width: calc(100% + 1rem);
        }

        .item {
          width: calc(100% / 3 - 2rem);
          margin-right: 2rem;
          margin-bottom: 1rem;

          @media screen and (max-width: 768px) {
            width: calc(100% / 2 - 1rem);
            margin-right: 1rem;
          }

          &.last {
            margin-right: calc(100% / 6 + 2rem);

            // margin-bottom: 2rem;
            @media screen and (max-width: 768px) {
              margin-right: calc(100% / 4 + 1rem);
            }
          }

          &.last-last {
            margin-right: calc(100% / 3 + 2rem);

            @media screen and (max-width: 768px) {
              margin-right: calc(100% / 2 + 1rem);
            }
          }

          .name {
            text-align: center;
            font-size: 0.9em;

            .cosmo {
              font-size: 0.7em;
            }
          }

          img {
            width: 100%;
            margin-bottom: 0.25rem;
          }
        }
      }
    }

    .stand {
      padding-top: 3rem;
      padding-bottom: 2rem;
      line-height: 1.4;

      .item-box {
        display: flex;
        margin: 2rem auto 0;
        flex-wrap: wrap;
        width: calc(77% + 1rem);
        justify-content: flex-end;

        @media screen and (max-width: 768px) {
          width: calc(100% + 0.5rem);
        }


        .item {
          width: calc(100% / 3 - 1rem);
          margin-right: 1rem;
          margin-bottom: 1rem;

          @media screen and (max-width: 768px) {
            width: calc(100% / 3 - 0.5rem);
            margin-right: 0.5rem;
          }

          &.last {
            margin-bottom: 2rem;
          }

          .name {
            text-align: center;
            font-size: 0.9em;
            line-height: 1.3;

            .cosmo {
              font-size: 0.7em;
            }
          }

          &.kumi {
            img {
              border-radius: 0.8rem;
              border: 1px solid $grey-op5;
              background-color: $white-op5;
            }
          }

          img {
            width: 100%;
            margin-bottom: 0.25rem;
          }
        }
      }
    }

    .badge {
      padding-top: 3rem;
      padding-bottom: 3rem;

      .item-box {
        display: flex;
        flex-wrap: wrap;
        width: calc(100% + 1rem);

        .item {
          margin-top: 2rem;
          width: calc(100% / 3 - 1rem);
          margin-right: 1rem;

          @media screen and (max-width: 768px) {
            width: calc(100% - 1rem);
          }

          .name {
            text-align: left;
            line-height: 1.6;

            .desc {
              line-height: 1.5;
              display: block;
            }

          }

          img {
            width: 100%;
            margin: 1rem auto 0;
            background-color: white;
            padding: 0.5rem;
          }
        }
      }


    }

    .seat {
      padding-top: 3rem;
      padding-bottom: 2rem;

      >.desc {
        line-height: 1.5;
        display: block;
        // margin-top: 0.5rem;
      }

      .item-box {
        display: flex;
        flex-wrap: wrap;
        width: calc(100% + 2rem);

        @media screen and (max-width: 768px) {
          width: calc(100% + 1rem);
        }

        .item {
          margin-top: 2rem;
          width: calc(100% / 3 - 2rem);
          margin-right: 2rem;

          @media screen and (max-width: 768px) {
            width: calc(100% - 1rem);
            margin-right: 1rem;
          }

          .name {
            text-align: left;
            line-height: 1.6;

            .desc {
              line-height: 1.5;
              display: block;
              // margin-top: 0.5rem;
            }
          }

          img {
            width: 100%;
            margin: 1rem auto 0;
          }
        }
      }


    }

    .recent {
      .head {
        margin-bottom: 2rem;
      }
    }

    .original {
      padding-bottom: 4rem;

      .item-box {
        display: flex;
        flex-wrap: wrap;
        width: calc(77% + 4rem);
        margin: 0 auto;

        @media screen and (max-width: 768px) {
          width: calc(100% + 1rem);
        }

        .item {
          margin-top: 2rem;
          width: calc(100% / 2 - 4rem);
          margin-right: 4rem;

          @media screen and (max-width: 768px) {
            width: calc(100% - 1rem);
            margin-right: 1rem;
          }

          .name {
            text-align: left;
            line-height: 1.6;

            @media screen and (max-width: 768px) {
              white-space: wrap;
            }

            .desc {
              line-height: 1.5;
              display: block;
            }
          }

          img {
            width: 100%;
            margin: 1rem auto 0;
          }
        }
      }


    }

    .buppan,
    .ec {
      .head {
        margin-bottom: 2rem;
      }
    }

    .ec {
      padding-bottom: 4rem;

      .notice {
        font-size: 0.9em;
        border: 1px solid $litegreen;
        padding: 1.5rem 2rem;
        margin-top: 3rem;

        @media screen and (max-width: 768px) {
          margin-top: 2rem;
          padding: 1rem;
        }

        &-head {
          font-size: 1 * $rem;
          margin-bottom: 0.5rem;
          display: block;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }

          @media screen and (min-width: 1024px) {
            font-size: 1rem;
          }
        }
      }
    }
  }
}

.footer-bar {
  font-size: 0.7rem;
  background: url(../../public/img/mre_menu.png) no-repeat;
  background-size: 100% 100%;
  background-position: center top;
  opacity: 0.8;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  text-align: left;

  .text {
    padding: 1rem 0;
    font-size: 0.7rem;
    padding-left: 4rem;
    padding-right: 4rem;
    color: white;
  }
}
</style>